import React, { Component } from "react";

class SimpleTextAreaRow extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { label, mandatory, readOnly, onChange, typeInputCase } = this.props;
    return (
      <div
        className="margin-bottom-20px"
        style={{
            display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignContent: "center",
        }}
      >        
        <div className="margin-5px">
          <div className="txt-site txt-11 txt-main txt-bold">
            <h4>
              {label} {mandatory && <span style={{ color: "red" }}>*</span>}
            </h4>
          </div>
        </div>
        <textarea
          {...this.props}
          style={{ backgroundColor: readOnly && "#E6E6E6", marginLeft: "30px" }}
          type="text"
          className="txt txt-sekunder-color"
          onChange={(e) => {
            e.target.value =
              typeInputCase === "normal"
                ? e.target.value
                : e.target.value.toUpperCase();
            onChange(e);
          }}
        />
      </div>
    );
  }
}

export default SimpleTextAreaRow;
